import React from "react";
import CorrespondanceType from "./correspondanceType";
class CorrespondanceTypeParent extends React.Component {
    render() {
        return <CorrespondanceType {...this.props} />;
    }
}


export default CorrespondanceTypeParent;